import * as moment from "moment";

/**
 * License session model
 * Represents the session created after successful license validation
 */
export class LicenseSession {
    accessToken: string;
    tokenType: string;
    expiresAt: moment.Moment;
    sessionId: string;
    jti: string;
    step: number;
    license: string;

    constructor(data: {
        access_token: string;
        token_type: string;
        expires_at: string;
        session_id: string;
        jti: string;
        step: number;
        license: string;
    }) {
        this.accessToken = data.access_token;
        this.tokenType = data.token_type;
        this.expiresAt = moment(data.expires_at);
        this.sessionId = data.session_id;
        this.jti = data.jti;
        this.step = data.step;
        this.license = data.license;
    }

    /**
     * Check if the license session has expired
     */
    hasExpired(): boolean {
        return moment().isAfter(this.expiresAt);
    }

    /**
     * Get the authorization header value
     */
    getAuthorizationHeader(): string {
        return `${this.tokenType} ${this.accessToken}`;
    }
}
